// extracted by mini-css-extract-plugin
export var chip = "_3a-0";
export var filterDropdown = "_3a-5";
export var filterItem = "_3a-6";
export var icon = "_3a-1";
export var removeButton = "_3a-3";
export var removeIcon = "_3a-4";
export var separator = "_3a-2";